import AiTruncate from './ai-truncate';
import './ai-truncate.scss';

// Define the custom element.
window.customElements.define('ai-truncate', AiTruncate);
